console.log("Starting application.js...")

// Import Rails UJS
import "@rails/ujs"
console.log("Rails UJS imported successfully")

// Import ActiveStorage
import "@rails/activestorage"
console.log("ActiveStorage imported successfully")

// Import Turbo
import "@hotwired/turbo-rails"
console.log("Turbo imported successfully")

// Import Trix and ActionText
import "trix"
console.log("Trix imported successfully")

// Wire up custom Trix events (image drop)
import "./trix_customizations.js"
console.log("Trix customizations imported successfully")

import "@rails/actiontext"
console.log("ActionText imported successfully")

// Import easy-autocomplete
import "easy-autocomplete"
console.log("Easy-autocomplete imported successfully")

// Import Select2 initialization
import "./select2_init.js"
console.log("Select2 initialization imported successfully")

// Import nested forms functionality (side effects only - event listeners are registered in the modules)
import "./nested-forms/addFields.js"
import "./nested-forms/removeFields.js"
console.log("Nested forms scripts loaded")

// Import logbook functionality
import "./logbook.js"
console.log("Logbook script loaded")

// Import aircraft N-number autocomplete
import "./aircraft/new_aircraft.js"
console.log("Aircraft autocomplete loaded")

// Import global search
import "./global_search.js"
console.log("Global search loaded")

// Import OCR text modal
import "./ocr_text_modal.js"
console.log("OCR text modal loaded")

// Import Stimulus controllers last
import "./controllers"
console.log("Controllers imported - Stimulus should be running")


console.log("Application loaded successfully with esbuild")